import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AgeVerification from './components/AgeVerification';
import CookiePopup from './components/CookiePopup';
import BackToTop from './components/BackToTop';
import ScrollToTop from './components/ScrollToTop';
import WarningBanner from './components/WarningBanner';
import Home from './pages/Home';
import Comparison from './pages/Comparison';
import OfferReview from './pages/OfferReview';
import About from './pages/About';
import FAQ from './pages/FAQ';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import Terms from './pages/Terms';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-dark-bg">
        <ScrollToTop />
        <AgeVerification />
        <WarningBanner />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/comparaison" element={<Comparison />} />
          <Route path="/offre/:id" element={<OfferReview />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/conditions" element={<Terms />} />
        </Routes>
        <Footer />
        <CookiePopup />
        <BackToTop />
      </div>
    </Router>
  );
}

export default App;
